import { render, staticRenderFns } from "./level-tabs.vue?vue&type=template&id=cc1acf1a&"
import script from "./level-tabs.vue?vue&type=script&lang=js&"
export * from "./level-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports